import { generateRoutes } from 'utils/generateRoutes';

export const mfaRecoveryRoutes = generateRoutes({}, 'mfa-recovery');
